export const EL_ICON_LIBRARY = {
    add: 'el-icon-circle-plus-outline',
    arrowLeft: 'el-icon-arrow-left',
    arrowRight: 'el-icon-arrow-right',
    arrowRightDouble: 'el-icon-d-arrow-right',
    bottom: 'el-icon-bottom',
    check: 'el-icon-check',
    circleClose: 'el-icon-circle-close',
    close: 'el-icon-close',
    copyDocument: 'el-icon-copy-document',
    delete: 'el-icon-delete',
    detail: 'el-icon-document',
    document: 'el-icon-document',
    download: 'el-icon-download',
    edit: 'el-icon-edit',
    forkSpoon: 'el-icon-fork-spoon',
    fullScreen: 'el-icon-full-screen',
    key: 'el-icon-key',
    medal: 'el-icon-medal',
    microphone: 'el-icon-microphone',
    minus: 'el-icon-minus',
    new: 'el-icon-circle-plus-outline',
    pieChart: 'el-icon-pie-chart',
    plus: 'el-icon-plus',
    preview: 'el-icon-data-board',
    printer: 'el-icon-printer',
    refresh: 'el-icon-refresh',
    refreshLeft: 'el-icon-refresh-left',
    refreshRight: 'el-icon-refresh-right',
    scissors: 'el-icon-scissors',
    search: 'el-icon-search',
    sort: 'el-icon-sort',
    sortDown: 'el-icon-sort-down',
    sunrise: 'el-icon-sunrise-1',
    tickets: 'el-icon-tickets',
    time: 'el-icon-time',
    tools: 'el-icon-s-tools',
    top: 'el-icon-top',
    topLeft: 'el-icon-top-left',
    toPublic: 'el-icon-wind-power',
    truck: 'el-icon-truck',
    upload: 'el-icon-upload',
    user: 'el-icon-user',
    info: 'el-icon-info'
} as const

export const SVG_ICON_NAMES = [
    'angle',
    'battery',
] as const

export const FA_ICON_LIBRARY = {
    arrowUpRight: 'arrow-up-right-from-square',
    batchEdit: 'pen-to-square',
    bind: 'link',
    businessTime: 'business-time',
    calendarCheck: 'calendar-check',
    calendarWeek: 'calendar-week',
    caretLeft: 'caret-left',
    caretRight: 'caret-right',
    book: 'book',
    chartArea: 'chart-area',
    chartPie: 'chart-pie',
    checkSlot: 'check-to-slot',
    circle: 'circle',
    circleCheck: 'circle-check',
    clock: 'clock',
    cloudUpload: 'cloud-arrow-up',
    compress: 'compress',
    diagnose: 'stethoscope',
    dust: 'cubes-stacked',
    expand: 'expand',
    export: 'download',
    fan: 'fan',
    filter: 'filter',
    faRefresh: 'arrows-rotate',
    gas: 'wind',
    gears: 'gears',
    handle: 'calendar-check',
    historyReport: 'chart-pie',
    image: 'image',
    images: 'images',
    import: 'upload',
    language: 'language',
    lineChart: 'line-chart',
    microchip: 'microchip',
    mobile: 'mobile-screen',
    paperPlane: 'paper-plane',
    pause: 'circle-pause',
    play: 'circle-play',
    stop: 'circle-stop',
    switch: 'layer-group',
    server: 'server',
    logout: 'right-from-bracket',
    sortAscWide: 'arrow-up-short-wide',
    sortDescWide: 'arrow-down-wide-short',
    tempVib: 'circle-exclamation',
    toCaseLibrary: 'book-medical',
    unBind: 'link-slash',
    voicePrint: 'file-audio',
    volume: 'volume-high',
    wave: 'chart-line',
    waveSquare: 'wave-square',
    networkTcp: 'network-wired',
} as const

export type ElIconType = keyof typeof EL_ICON_LIBRARY
export type SvgIconType = typeof SVG_ICON_NAMES[number]
export type FaIconType = keyof typeof FA_ICON_LIBRARY
export type JJIconType = ElIconType | SvgIconType | FaIconType

export interface IIconProps {
    name: JJIconType
    isFa?: boolean
    isEl?: boolean
    isSvg?: boolean
    fa?: string
    el?: string
}

export const EL_ICON_NAMES = Object.keys(EL_ICON_LIBRARY) as ElIconType[]
export const FA_ICON_NAMES = Object.keys(FA_ICON_LIBRARY) as FaIconType[]
export const JJ_ICON_NAMES = [
    ...EL_ICON_NAMES,
    ...SVG_ICON_NAMES,
    ...FA_ICON_NAMES,
] as JJIconType[]

export const EL_ICON_CLASS_TO_JJ_ICON = EL_ICON_NAMES.reduce((table, name) => {
    table[EL_ICON_LIBRARY[name]] = name
    return table
}, {} as Record<string, ElIconType>)

export const FA_ICON_CLASS_TO_JJ_ICON = FA_ICON_NAMES.reduce((table, name) => {
    table[FA_ICON_LIBRARY[name]] = name
    return table
}, {} as Record<string, FaIconType>)

function hasOwn(table: object, key: string) {
    return Object.prototype.hasOwnProperty.call(table, key)
}

export function toFaIcon(type: FaIconType) {
    return FA_ICON_LIBRARY[type]
}

export function toELIcon(type: ElIconType) {
    return EL_ICON_LIBRARY[type]
}

export function isElIcon(type: string): type is ElIconType {
    return hasOwn(EL_ICON_LIBRARY, type)
}

export function isSvgIcon(type: string): type is SvgIconType {
    return SVG_ICON_NAMES.includes(type as SvgIconType)
}

export function isFaIcon(type: string): type is FaIconType {
    return hasOwn(FA_ICON_LIBRARY, type)
}
